import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const SAFE_IMAGE_SRC = /^\/api\/regulations\/images\/\d+$/;
export const SAFE_HREF = /^https?:\/\//i;

export function isSafeImageSrc(src) {
  return SAFE_IMAGE_SRC.test(String(src || ""));
}

export function isSafeHref(href) {
  return SAFE_HREF.test(String(href || ""));
}

export function transformLinkUri(href) {
  return isSafeHref(href) ? String(href) : "";
}

export function transformImageUri(src) {
  return isSafeImageSrc(src) ? String(src) : "";
}

function Heading({ level, children }) {
  const tag = `h${Math.min(Number(level) + 2, 6)}`;
  return React.createElement(tag, null, children);
}

function MarkdownLink({ href, children }) {
  if (!isSafeHref(href)) {
    return <>{children}</>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

function MarkdownImage({ src, alt }) {
  if (!isSafeImageSrc(src)) {
    return <>{`[изображение: ${alt || "без названия"}]`}</>;
  }
  return <img src={src} alt={alt} loading="lazy" decoding="async" />;
}

const markdownComponents = {
  h1: Heading,
  h2: Heading,
  h3: Heading,
  h4: Heading,
  h5: Heading,
  h6: Heading,
  a: MarkdownLink,
  img: MarkdownImage,
};

export default function MarkdownView({ source }) {
  const markdown = String(source ?? "");
  if (!markdown.trim()) {
    return <p className="reg-empty-body">Текст пока не заполнен.</p>;
  }

  return (
    <div className="reg-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        transformLinkUri={transformLinkUri}
        transformImageUri={transformImageUri}
        components={markdownComponents}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
